// @flow
import * as React from 'react';
import CustomerDetailsForm from './CustomerDetailsForm';
import AgencyRequestModal from '../../components/AgencyRequestModal';
import type { Authentication, Organisation, Dispatch } from '../../types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as organisationCreators from '../../actions/organisations/organisationCreators';
import * as customerCreators from '../../actions/customers/customerCreators';
import { getIndustries } from '../../actions/industries/basicCreators';
import { checkLoggedInUserIsGlobalAdmin } from '../../actions/authentication/authCreators';
import { removeUserFromOrganisation } from '../../actions/users/organisationCreators';
import { getSetting } from '../../actions/settings/settingsCreators';
import type { Customer } from '../../types/Customer';
import { Grid, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

type Props = {
  params: {
    customerId: string
  },
  router: any,
  currentCustomer: Organisation,
  authentication: Authentication,
  updateCurrentCustomer: (i: number, s?: boolean) => Promise<Organisation>,
  getCustomerSettings: (i?: ?number) => Promise<void>,
  updateCustomer: (o: Organisation) => Promise<Object>,
  addCustomer: (o: Organisation) => Promise<Object>,
  clearCurrentCustomer: () => void,
  getIndustries: () => Promise<Object>,
  registerOrganisation: (v: Object) => Promise<Object>,
  updateCurrentOrganisation: (oid: number) => Promise<Object>,
  getOrganisations: () => Promise<Object>,
  customers: Array<Customer>
};

type State = {
  isSaving: boolean,
  errorMsg: ?string,
  successMsg?: string,
  agencyRequest?: boolean
};

class CreateNewCustomer extends React.Component<Props, State> {
  timeoutId: any;
  screenReaderContent: any;
  static displayName = 'CreateNewCustomer';

  constructor(props: Props) {
    super(props);
    this.state = {
      isSaving: false,
      errorMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const customerId = parseInt(this.props.params.customerId, 10);

    const { authentication, router } = this.props;
    if (authentication.user.isInternalAdminUser) {
      router.push('/customers/new');
    } else {
      this.screenReaderContent.focus();
    }

    if (customerId) {
      this.props.updateCurrentCustomer(customerId);
    }

    this.props.clearCurrentCustomer();
    this.props.getCustomerSettings();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = (values: any) => {
    this.setState({ isSaving: true, errorMsg: undefined });
    if (values.id) {
      this.props
        .updateCustomer(values)
        .then(
          response => this.success(response, false, values.agencyRequest),
          error => this.failure(error)
        );
    } else {
      this.props
        .registerOrganisation(values)
        .then(
          response => this.success(response, true),
          error => this.failure(error)
        );
    }
  };

  success = (
    response: any,
    redirect: boolean = false,
    agencyRequest: boolean = false
  ) => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!',
      agencyRequest
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined }),
      3000
    );

    if (redirect) {
      const newCustomerId = response.data.id;

      this.props.getOrganisations().then(
        response => {
          this.props.updateCurrentOrganisation(newCustomerId);
          this.props.router.push(`/`);
        },
        error => this.failure(error)
      );
    }
  };

  failure = (error: any) => {
    this.setState({ isSaving: false, errorMsg: error.data.message });
  };

  closeModal = () => {
    this.setState({
      agencyRequest: false
    });
  };

  render() {
    return (
      <div>
        <Grid fluid className="customer-details">
          <Helmet>
            <title>Create New Customer | Campaign Targeter</title>
          </Helmet>
          <Row>
            <Col sm={12} className="generic-main-content-wrapper">
              <h3
                className="screen-reader-only"
                tabIndex="-1"
                ref={i => (this.screenReaderContent = i)}
              >
                Creating New Customer
              </h3>
              <Row>
                <Col
                  sm={12}
                  className="customer-maincontent customer-create-new-container"
                >
                  <h3
                    className="screen-reader-only"
                    tabIndex="-1"
                    ref={i => (this.screenReaderContent = i)}
                  >
                    Showing details for customer{' '}
                    {this.props.currentCustomer.name}
                  </h3>

                  <CustomerDetailsForm
                    onSubmit={this.handleSubmit}
                    initialValues={this.props.currentCustomer}
                    enableReinitialize={true}
                    currentCustomer={this.props.currentCustomer}
                    isNew={true}
                    isSaving={this.state.isSaving}
                    errorMsg={this.state.errorMsg}
                    successMsg={this.state.successMsg}
                    isInternalAdminUser={
                      this.props.authentication.user.isInternalAdminUser
                    }
                  />
                  <AgencyRequestModal
                    show={this.state.agencyRequest}
                    onHide={this.closeModal}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    organisations: state.organisations,
    locations: state.locations,
    customers: state.customers,
    currentLocation: state.currentLocation,
    currentCustomer: state.currentCustomer,
    currentOrganisation: state.currentOrganisation,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      ...organisationCreators,
      ...customerCreators,
      removeUserFromOrganisation,
      checkLoggedInUserIsGlobalAdmin,
      getSetting,
      getIndustries
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateNewCustomer);



// WEBPACK FOOTER //
// ./src/containers/customer/CreateNewCustomer.js